import { Component, Input } from '@angular/core';
import { Idea } from '@models/Sessions/Idea/Idea';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '@services/config.service';

@Component({
  selector: 'app-idea-moves-modal',
  templateUrl: './idea-moves-modal.component.html',
  styleUrls: ['./idea-moves-modal.component.scss'],
})
export class IdeaMovesModalComponent {
  @Input() idea: Idea;

  constructor(
    public activeModal: NgbActiveModal,
    public config: ConfigService,
  ) {}

  dismiss() {
    this.activeModal.dismiss();
  }

  close() {
    this.activeModal.close('nav');
  }

  moveDate(move: any) {
    const date = new Date(move.moved_on);
    const months = [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'May',
      'Jun',
      'Jul',
      'Aug',
      'Sep',
      'Oct',
      'Nov',
      'Dec',
    ];
    return `${date.getDate()} ${months[date.getMonth()]} ${date.getFullYear()}`;
  }
}
